module.exports = __webpack_public_path__ + "img/qa.03340b2d.svg";